module.exports = __webpack_public_path__ + "img/maximilian-block-avatar.91e2536c.jpg";